<template>
    <Typeahead :search-term="searchTerm" :showResults="showResults"/>
</template>

<script>
    import Typeahead from "./components/Typeahead";
    
    export default {
        name: "App",
        props: ['searchTerm'],
        components: {
            Typeahead
        },
        data() {
            return {
                showResults: false,
            }
        },
        methods: {
            // Adds an event listener that will conditional hide the items wrapper
            addEventListeners() {
                const targetDiv = document.querySelector('#event-typeahead')
                document.addEventListener('click', (e) => {
                    this.showResults = e.composedPath().includes(targetDiv)
                })

                // Will help with keyboard navigation
                document.addEventListener('focusin', (e) => {
                    this.showResults = e.composedPath().includes(targetDiv)
                })
            },
        },
        mounted() {
            this.addEventListeners();
        }
    }
</script>

<style scoped>

</style>
